// import React, { useState } from "react";

// import { Outlet } from "react-router-dom";
// import Header from "../components/Layout/Header";
// import NavbarCollapse from "../components/Layout/NavbarCollapse";

// const AppLayout = () => {
//   const [isNavOpen, setIsNavOpen] = useState(false);
//   console.log(isNavOpen);
//   return (
//     <div className="relative z-10 bg-dt-main">
//       <Header openNav={setIsNavOpen} />
//       <NavbarCollapse isOpen={isNavOpen} onClose={setIsNavOpen} />
//       <Outlet />
//     </div>
//   );
// };

// export default AppLayout;

import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "../components/Layout/Header";
import NavbarCollapse from "../components/Layout/NavbarCollapse";

const AppLayout = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const location = useLocation();

  // Add any routes where you want to hide the header
  const hideHeaderRoutes = ["/devtrove/admin-signin"];

  const shouldHideHeader = hideHeaderRoutes.includes(location.pathname);

  return (
    <div className="relative z-10 bg-dt-main">
      {!shouldHideHeader && <Header openNav={setIsNavOpen} />}
      {!shouldHideHeader && (
        <NavbarCollapse isOpen={isNavOpen} onClose={setIsNavOpen} />
      )}
      <Outlet />
    </div>
  );
};

export default AppLayout;
